import { addSlidesTabIndex } from '@gravity-global/helpers/swiper/add-slides-tab-index';

const featuresSliderInit = () => {
  const mainPattern = document.querySelectorAll('.gg-features-benefits');

  mainPattern.forEach((module) => {
    const swipers = module.querySelector('.gg-swiper-features');
    const swiperWrapper = module.querySelector('.gg-swiper-features-wrapper');
    const swiperSlides = module.querySelectorAll('.gg-swiper-features-slide');
    let carousel = ''
    if (!swipers || !swiperWrapper) {
      return;
    }
    swiperSlides.forEach((slide, index) => {
      slide.classList.add('fade-in-up', `delay-${index}`);
    });
    if (window.innerWidth < 1200) {
      if(swipers.classList.contains('swiper-container')) {
        return;
      }
      const swiperNext = module.querySelector('.gg-features-benefits__next-btn > a');
      const swiperPrev = module.querySelector('.gg-features-benefits__prev-btn > a');

    if (swiperPrev) swiperPrev.setAttribute('rel', 'prev');
    if (swiperNext) swiperNext.setAttribute('rel', 'next');

      swipers.classList.add('swiper-container');
      swiperWrapper.classList.add('swiper-wrapper');
      swiperSlides.forEach((slide) => {
        slide.classList.add('swiper-slide');
      });

      carousel = new window.Swiper(swipers, {
        loop: false,
        centeredSlides: false,
        watchOverflow: true,
        watchSlidesProgress: true,
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        allowTouchMove: true,
        navigation: {
          prevEl: swiperPrev,
          nextEl: swiperNext,
        },
        breakpoints: {
          1200: {
            slidesPerView: 'auto',
          },
          1025: {
            slidesPerView: 2.1,
          },
          750: {
            slidesPerView: 2,
          },
          480: {
            slidesPerView: 1,
          },
          200: {
            slidesPerView: 1,
          },
        },
        on: {
          init: (swiper) => addSlidesTabIndex(swiper),
          slideChange: (swiper) => addSlidesTabIndex(swiper),
        },
      });
      setTimeout(() => {
        carousel.init();
      }, 300);
    } else {
      if(swipers.classList.contains('swiper-container')) {
        swipers.classList.remove('swiper-container');
        swiperWrapper.classList.remove('swiper-wrapper');
        swiperWrapper.style.transition = 'none';
        swiperSlides.forEach((slide) => {
          slide.classList.remove('swiper-slide');
        });
        
        if (carousel && typeof carousel.destroy === 'function') {
          carousel.destroy(true, true);
        }
      }
    }
  });
};
featuresSliderInit();
window.addEventListener('resize', () => {
  featuresSliderInit();
});
